<!-- eslint-disable -->
<template lang="pug">
    .form-container
        .box(v-if="stage")
            div(
                :is="`${type}-form`"
                :slug="type"
                :id="id"
                :userId="userId"
                :stageId="stageId"
                ref="form"
                :levelAnswerDuration="levelAnswerDuration"
                :generatorSettings="generatorSettings"
                :generatorGameIndex="generatorGameIndex"
            )
                .help-block(slot="help" )
                    | {{ $i18n.t('common.common_helpText_notAvailableOptions') }}
</template>

<script>
    /*eslint-disable*/
    const MultiplicationAndDivisionForm = () => import('../games/games-forms/MultiplicationAndDivisionForm.vue');
    const MultiplicationAndDivisionPreview = () => import('../games/games-previews/MultDivPreview.vue');
    const AdditionAndSubtractionForm = () => import('../games/games-forms/AddSubForm.vue');
    const AdditionAndSubtractionPreview = () => import('../games/games-previews/AddSubPreview.vue');
    const AdditionAndSubtractionWithTimeForm = () => import('../games/games-forms/AddSubForm.vue');
    const AdditionAndSubtractionWithTimePreview = () => import('../games/games-previews/AddSubPreview.vue');
    const FlashCardsForm = () => import('../games/games-forms/FlashCardsForm.vue');
    const FlashCardsPreview = () => import('../games/games-previews/FlashCardsPreview.vue');
    const InteractiveFlashCardsForm = () => import('../games/games-forms/FlashCardsForm.vue');
    const InteractiveFlashCardsPreview = () => import('../games/games-previews/FlashCardsPreview.vue');
    const EquationForm = () => import('../games/games-forms/EquationForm.vue');
    const EquationPreview = () => import('../games/games-previews/EquationPreview.vue');
    const AnzanForm = () => import('../games/games-forms/AnzanForm.vue');
    const AnzanPreview = () => import('../games/games-previews/AnzanPreview.vue');
    const PuzzleForm = () => import('../games/games-forms/PuzzleForm.vue');
    const PuzzlePreview = () => import('../games/games-previews/PuzzlePreview.vue');
    const ChainsForm = () => import('../games/games-forms/ChainsForm.vue');
    const ChainsPreview = () => import('../games/games-previews/ChainsPreview.vue');
    const CouplesForm = () => import('../games/games-forms/CouplesForm.vue');
    const CouplesPreview = () => import('../games/games-previews/CouplesPreview.vue');
    const SchulteForm = () => import('../games/games-forms/SchulteForm.vue');
    const SchultePreview = () => import('../games/games-previews/SchultePreview.vue');
    const WordsFieldForm = () => import('../games/games-forms/WordsFieldForm.vue');
    const WordsFieldPreview = () => import('../games/games-previews/WordsFieldPreview.vue');
    const ScannerForm = () => import('../games/games-forms/ScannerForm.vue');
    const ScannerPreview = () => import('../games/games-previews/ScannerPreview.vue');
    const AnagramsForm = () => import('../games/games-forms/AnagramsForm.vue');
    const AnagramsPreview = () => import('../games/games-previews/AnagramsPreview.vue');
    const TextsForm = () => import('../games/games-forms/TextsForm.vue');
    const TextsPreview = () => import('../games/games-previews/TextsPreview.vue');
    const LettersFieldForm = () => import('../games/games-forms/LettersFieldForm.vue');
    const LettersFieldPreview = () => import('../games/games-previews/LettersFieldPreview.vue');
    const CatchWordForm = () => import('../games/games-forms/CatchWordForm.vue');
    const CatchWordPreview = () => import('../games/games-previews/CatchWordPreview.vue');
    const MatrixForm = () => import('../games/games-forms/MatrixForm.vue');
    const MatrixPreview = () => import('../games/games-previews/MatrixPreview.vue');
    const NavigatorForm = () => import('../games/games-forms/NavigatorForm.vue');
    const NavigatorPreview = () => import('../games/games-previews/NavigatorPreview.vue');
    const SynonymsForm = () => import('../games/games-forms/SynonymsForm.vue');
    const SynonymsPreview = () => import('../games/games-previews/SynonymsPreview.vue');
    const VisionFieldForm = () => import('../games/games-forms/VisionFieldForm.vue');
    const VisionFieldPreview = () => import('../games/games-previews/VisionFieldPreview.vue');
    const TransferSyllablesForm = () => import('../games/games-forms/TransferSyllablesForm.vue');
    const TransferSyllablesPreview = () => import('../games/games-previews/TransferSyllablesPreview.vue');
    const HardSoftConsonantsForm = () => import('../games/games-forms/HardSoftConsonantsForm.vue');
    const HardSoftConsonantsPreview = () => import('../games/games-previews/HardSoftConsonantsPreview.vue');
    const DivideItRightForm = () => import('../games/games-forms/DivideItRightForm.vue');
    const DivideItRightPreview = () => import('../games/games-previews/DivideItRightPreview.vue');
    const ChooseItRightForm = () => import('../games/games-forms/ChooseItRightForm.vue');
    const ChooseItRightPreview = () => import('../games/games-previews/ChooseItRightPreview.vue');
    const DivideUnstressedVowelsForm = () => import('../games/games-forms/DivideUnstressedVowelsForm.vue');
    const DivideUnstressedVowelsPreview = () => import('../games/games-previews/DivideUnstressedVowelsPreview.vue');
    const WordStructureForm = () => import('../games/games-forms/WordStructureForm.vue');
    const WordStructurePreview = () => import('../games/games-previews/WordStructurePreview.vue');
    const SentenceParsingForm = () => import('../games/games-forms/SentenceParsingForm.vue');
    const SentenceParsingPreview = () => import('../games/games-previews/SentenceParsingPreview.vue');
    const VocabularyWordsRusForm = () => import('../games/games-forms/VocabularyWordsRusForm.vue');
    const VocabularyWordsRusPreview = () => import('../games/games-previews/VocabularyWordsRusPreview.vue');
    const TranscriptionInWordForm = () => import('../games/games-forms/TranscriptionInWordForm.vue');
    const TranscriptionInWordPreview = () => import('../games/games-previews/TranscriptionInWordPreview.vue');
    const LettersSoundsSyllablesForm = () => import('../games/games-forms/LettersSoundsSyllablesForm.vue');
    const LettersSoundsSyllablesPreview = () => import('../games/games-previews/LettersSoundsSyllablesPreview.vue');
    const VoicedAndDeafConsonantsForm = () => import('../games/games-forms/VoicedAndDeafConsonantsForm.vue');
    const VoicedAndDeafConsonantsPreview = () => import('../games/games-previews/VoicedAndDeafConsonantsPreview.vue');
    const PartsOfSpeechForm = () => import('../games/games-forms/PartsOfSpeechForm.vue');
    const PartsOfSpeechPreview = () => import('../games/games-previews/PartsOfSpeechPreview.vue');
    const ParsingSentencePartsSpeechForm = () => import('../games/games-forms/ParsingSentencePartsSpeechForm.vue');
    const ParsingSentencePartsSpeechPreview = () => import('../games/games-previews/ParsingSentencePartsSpeechPreview.vue');
    const SortOneManyForm = () => import('../games/games-forms/SortOneManyForm.vue');
    const SortOneManyPreview = () => import('../games/games-previews/SortOneManyPreview.vue');
    const GenericWordsForm = () => import('../games/games-forms/GenericWordsForm.vue');
    const GenericWordsPreview = () => import('../games/games-previews/GenericWordsPreview.vue');
    const VerbTensesForm = () => import('../games/games-forms/VerbTensesForm.vue');
    const VerbTensesPreview = () => import('../games/games-previews/VerbTensesPreview.vue');
    const PunctuationMarksForm = () => import('../games/games-forms/PunctuationMarksForm.vue');
    const PunctuationMarksPreview = () => import('../games/games-previews/PunctuationMarksPreview.vue');
    const AlphabetForm = () => import('../games/games-forms/AlphabetForm.vue');
    const AlphabetPreview = () => import('../games/games-previews/AlphabetPreview.vue');
    const ConnectThePuzzlesForm = () => import('../games/games-forms/ConnectThePuzzlesForm.vue');
    const ConnectThePuzzlesPreview = () => import('../games/games-previews/ConnectThePuzzlesPreview.vue');
    const OrthographForm = () => import('../games/games-forms/OrthographForm.vue');
    const OrthographPreview = () => import('../games/games-previews/OrthographPreview.vue');

    import { mapState } from 'vuex';

    export default {
        props: ['index', 'stageId', 'id', 'userId', 'generatorSettings', 'generatorGameIndex'],
        data() {
            return {
                type: null,
                action: null,
                stage: null,
            };
        },
        watch: {
            $route: {
                handler() {
                    this.setVariables();
                },
            },
            immediate: true,
        },
        created() {
            this.setVariables();
        },
        methods: {
            setVariables() {
                this.stage = this.levels[+this.index].stages[+this.stageId];
                this.levelAnswerDuration = this.levels[+this.index].answerDuration;
                this.type = this.generatorSettings
                    ? this.stage.games[+this.id].parameters.default.games[this.generatorGameIndex].slug
                    : this.stage.games[+this.id].slug;
            },
            cancel() {
                if (this.stageId) {
                    this.$router.push({ name: 'battle-level:edit', params: { id: this.stageId } });
                } else {
                    this.$router.push({ name: 'battle-level:create' });
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            let allowedPaths = [
                'battle-stage-game:edit',
                'battle-level:create',
                'battle-training-level:create',
                'battle-training-stage-game:edit',
            ];
            if (!allowedPaths.includes(to.name)) {
                this.$store.dispatch('setIntermediateBattleStage', null);
                this.$store.dispatch('setGamesParameters', null);
            }
            next();
        },
        computed: {
            ...mapState({
                levels: state => state.battle.intermediateBattleStage.levels,
            }),
            title() {
                switch (this.type) {
                    case 'MultiplicationAndDivision':
                        return this.$i18n.t('common.common_gameName_multiplicationAndDivision');
                    case 'AdditionAndSubtraction':
                        return this.$i18n.t('common.common_gameName_additionAndSubtraction');
                    case 'AdditionAndSubtractionWithTime':
                        return this.$i18n.t('common.common_gameName_additionAndSubtractionWithTime');
                    case 'FlashCards':
                        return this.$i18n.t('common.common_gameName_flashCards');
                    case 'InteractiveFlashCards':
                        return this.$i18n.t('common.common_gameName_interactiveFlashCards');
                    case 'Equation':
                        return this.$i18n.t('common.common_gameName_equation');
                    case 'Anzan':
                        return this.$i18n.t('common.common_gameName_anzan');
                    case 'Puzzle':
                        return this.$i18n.t('common.common_gameName_puzzle');
                    case 'Chains':
                        return this.$i18n.t('common.common_gameName_chains');
                    case 'Couples':
                        return this.$i18n.t('common.common_gameName_couples');
                    case 'Schulte':
                        return this.$i18n.t('common.common_gameName_schulte');
                    case 'Scanner':
                        return this.$i18n.t('common.common_gameName_scanner');
                    case 'Anagrams':
                        return this.$i18n.t('common.common_gameName_anagrams');
                    case 'WordsField':
                        return this.$i18n.t('common.common_gameName_wordsField');
                    case 'Texts':
                        return this.$i18n.t('common.common_gameName_texts');
                    case 'LettersFied':
                        return this.$i18n.t('common.common_gameName_lettersField');
                    case 'CatchWord':
                        return this.$i18n.t('common.common_gameName_catchWord');
                    case 'VisionField':
                        return this.$i18n.t('common.common_gameName_visionField');
                    case 'Matrix':
                        return this.$i18n.t('common.common_gameName_matrix');
                    case 'Navigator':
                        return this.$i18n.t('common.common_gameName_navigator');
                    case 'Synonyms':
                        return this.$i18n.t('common.common_gameName_synonyms');
                    case 'TransferSyllables':
                        return this.$i18n.t('common.common_gameName_transferSyllables');
                    case 'HardSoftConsonants':
                        return this.$i18n.t('common.common_gameName_hardSoftConsonants');
                    case 'DivideItRight':
                        return this.$i18n.t('common.common_gameName_divideItRight');
                    case 'ChooseItRight':
                        return this.$i18n.t('common.common_gameName_chooseItRight');
                    case 'DivideUnstressedVowels':
                        return this.$i18n.t('common.common_gameName_divideUnstressedVowels');
                    case 'WordStructure':
                        return this.$i18n.t('common.common_gameName_wordStructure');
                    case 'SentenceParsing':
                        return this.$i18n.t('common.common_gameName_sentenceParsing');
                    case 'VocabularyWordsRus':
                        return this.$i18n.t('common.common_gameName_vocabularyWordsRus');
                    case 'TranscriptionInWord':
                        return this.$i18n.t('common.common_gameName_transcriptionInWord');
                    case 'LettersSoundsSyllables':
                        return this.$i18n.t('common.common_gameName_lettersSoundsSyllables');
                    case 'PartsOfSpeech':
                        return this.$i18n.t('common.common_gameName_partsOfSpeech');
                    case 'ParsingSentencePartsSpeech':
                        return this.$i18n.t('common.common_gameName_parsingSentencePartsSpeech');
                    case 'GenericWords':
                        return this.$i18n.t('common.common_gameName_genericWords');
                    case 'VerbTenses':
                        return this.$i18n.t('common.common_gameName_verbTenses');
                    case 'SortOneMany':
                        return this.$i18n.t('common.common_gameName_sortOneMany');
                    case 'VoicedAndDeafConsonants':
                        return this.$i18n.t('common.common_gameName_voicedAndDeafConsonants');
                    case 'PunctuationMarks':
                        return this.$i18n.t('common.common_gameName_punctuationMarks');
                    case 'Alphabet':
                        return this.$i18n.t('common.common_gameName_alphabet');
                    case 'ConnectThePuzzles':
                        return this.$i18n.t('common.common_gameName_connectThePuzzles');
                    case 'Orthograph':
                        return this.$i18n.t('common.common_gameName_orthograph');
                }
            },
        },
        components: {
            MultiplicationAndDivisionForm,
            MultiplicationAndDivisionPreview,
            AdditionAndSubtractionForm,
            AdditionAndSubtractionPreview,
            AdditionAndSubtractionWithTimeForm,
            AdditionAndSubtractionWithTimePreview,
            FlashCardsForm,
            FlashCardsPreview,
            InteractiveFlashCardsForm,
            InteractiveFlashCardsPreview,
            EquationForm,
            EquationPreview,
            AnzanForm,
            AnzanPreview,
            PuzzleForm,
            PuzzlePreview,
            ChainsForm,
            ChainsPreview,
            CouplesForm,
            CouplesPreview,
            ScannerForm,
            ScannerPreview,
            SchulteForm,
            SchultePreview,
            WordsFieldForm,
            WordsFieldPreview,
            AnagramsForm,
            AnagramsPreview,
            TextsForm,
            TextsPreview,
            LettersFieldPreview,
            LettersFieldForm,
            CatchWordPreview,
            CatchWordForm,
            MatrixForm,
            MatrixPreview,
            NavigatorForm,
            NavigatorPreview,
            SynonymsForm,
            SynonymsPreview,
            VisionFieldForm,
            VisionFieldPreview,
            TransferSyllablesForm,
            TransferSyllablesPreview,
            HardSoftConsonantsForm,
            HardSoftConsonantsPreview,
            DivideItRightForm,
            DivideItRightPreview,
            ChooseItRightForm,
            ChooseItRightPreview,
            DivideUnstressedVowelsForm,
            DivideUnstressedVowelsPreview,
            WordStructureForm,
            WordStructurePreview,
            SentenceParsingForm,
            SentenceParsingPreview,
            VocabularyWordsRusForm,
            VocabularyWordsRusPreview,
            TranscriptionInWordForm,
            TranscriptionInWordPreview,
            LettersSoundsSyllablesForm,
            LettersSoundsSyllablesPreview,
            VoicedAndDeafConsonantsForm,
            VoicedAndDeafConsonantsPreview,
            PartsOfSpeechForm,
            PartsOfSpeechPreview,
            ParsingSentencePartsSpeechForm,
            ParsingSentencePartsSpeechPreview,
            SortOneManyForm,
            SortOneManyPreview,
            GenericWordsForm,
            GenericWordsPreview,
            VerbTensesForm,
            VerbTensesPreview,
            PunctuationMarksForm,
            PunctuationMarksPreview,
            AlphabetForm,
            AlphabetPreview,
            ConnectThePuzzlesForm,
            ConnectThePuzzlesPreview,
            OrthographForm,
            OrthographPreview,
        },
    };
</script>
<style lang="scss" scoped>
    .form-container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .box {
        margin: 0;
        padding: 30px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
    }
</style>
